//////////////////
// IMPORTS
//////////////////
// schema
import * as ISchema from "@schema";
// libraries
import * as React from "react";
import { createFragmentContainer } from "react-relay";
// header imports
import { IProps, IContainer, IStandardProps } from "./SuggestionCardHeader.d";
import { suggestionCardHeaderFragments } from "./SuggestionCardHeader.gql";
import { SuggestionCardHeaderStandard } from "./SuggestionCardHeaderStandard";
import { SuggestionCardHeaderTip } from "./SuggestionCardHeaderTip";
// util
import { maybeGetPrimaryTeamFromOrg } from "@util/team.util";
import {
  getSuggestionCardLabel,
  maybeGetRichSuggestionConfig,
  maybeGetMoreInfoLink,
  maybeGetMoreInfoTracking,
} from "@util/suggestion.util";

//////////////////
// COMPONENT
//////////////////
export class SuggestionCardHeaderCmpt extends React.Component<IProps> {
  // generates the props that are common between standard and tip headers
  private generateSharedProps = (
    feedSuggestion: ISchema.IFeedSuggestion,
    removeCard: IProps["removeCard"],
    org: ISchema.IOrg,
  ): IStandardProps => {
    const { suggestionType, occurredMillis, text } = feedSuggestion;
    const maybeTeam = maybeGetPrimaryTeamFromOrg(org);
    const teamName = maybeTeam ? maybeTeam.teamName : undefined;
    const label = getSuggestionCardLabel(suggestionType, teamName);
    const moreInfoLink = maybeGetMoreInfoLink(suggestionType);
    const moreInfoTracking = maybeGetMoreInfoTracking(suggestionType);

    return {
      label,
      moreInfoLink,
      moreInfoTracking,
      occurredMillis,
      removeCard,
      suggestionType,
      text,
    };
  };

  // render either tip header or standard header (for everything else)
  public render() {
    const { feedSuggestion, removeCard, org } = this.props;
    const sharedProps = this.generateSharedProps(feedSuggestion, removeCard, org);
    const tipConfig = maybeGetRichSuggestionConfig(feedSuggestion.suggestionPayload, org);

    if (!!tipConfig) {
      // the headers for the tips are much more elaborate and non-standard
      return <SuggestionCardHeaderTip {...sharedProps} tipConfig={tipConfig} />;
    }

    return <SuggestionCardHeaderStandard {...sharedProps} />;
  }
}

//////////////////
// RELAY
//////////////////
export const SuggestionCardHeader = createFragmentContainer<IContainer>(
  SuggestionCardHeaderCmpt,
  suggestionCardHeaderFragments,
);
